import React from "react";
import {getAllDeals} from "src/server/preloader/dealsPage";
import {
  getCacheRevalidateInterval,
  getTags,
  makeTimedGetServerSideProps,
  makeTimedGetStaticProps,
} from "src/server/preloader/utils";
import absoluteUrl from "next-absolute-url";
import useThemeConfig from "src/themes/useThemeConfig";
import {makeProductsPage} from "src/core/pages/productsPagesFactory";
import routes from "src/core/common/routes";
import * as Sentry from "@sentry/nextjs";
import {getData, ServerContextProvider} from "src/server/components/context";
import {isClient} from "src/server/utils/isClient";
import Metadata from "src/core/seo/components/Metadata";

function ThemedDealsPage(props) {
  const config = useThemeConfig();
  const ThemedDealsPage = config.pages.DealsPage;

  return <ThemedDealsPage {...props} />;
}

const Deals = makeProductsPage(
  () => ({
    pathname: routes.deals,
    params: [],
  }),
  ThemedDealsPage
);

function DealsPage({metadata, ...props}) {
  return (
    <ServerContextProvider data={getData({...props})}>
      {!isClient && <Metadata {...metadata} />}
      <Deals />
    </ServerContextProvider>
  );
}

const __getServerSideProps = makeTimedGetServerSideProps(async context => {
  const {host} = absoluteUrl(context.req);
  const {shop, ...params} = context.query;
  const sMaxage = getCacheRevalidateInterval();
  context.res.setHeader("Cache-Control", `s-maxage=${sMaxage}, stale-while-revalidate`);

  const data = await getAllDeals({shop, host, params});
  return {
    props: {
      ...data,
    },
  };
});

const __getStaticProps = makeTimedGetStaticProps(async context => {
  const {shop, ...params} = context.params;
  const data = await getAllDeals({shop, host: null, params});
  const revalidate = getCacheRevalidateInterval();
  return {
    props: {
      ...data,
    },
    revalidate,
  };
});

export async function ssr_getServerSideProps(context) {
  Sentry.setTags(getTags("getServerSideProps", context));

  return __getServerSideProps(context);
}

export async function isr_getStaticProps(context) {
  Sentry.setTags(getTags("getStaticProps", context));

  return __getStaticProps(context);
}

export async function isr_getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}

export default DealsPage;
